import React, {useState} from 'react'
import {Form, Button, FloatingLabel, Col, InputGroup } from 'react-bootstrap'

export default function JournalEditForm(props) {
    const [newJournal, setNewJournal] = useState(props.journal)

    const handleChange = (event) =>{
        const attributeToChange = event.target.name
        const newValue = event.target.value
    
        const journal = {...newJournal}
        journal[attributeToChange] = newValue
        // console.log(journal)
        setNewJournal(journal)
    }
    
    const handleSubmit = (event) => {
        event.preventDefault();
        props.editJournal(newJournal);
        event.target.reset();
    }
    
    
      return (
        <div>
        <p>How focused were you? (1-10)</p>
        <h2>{newJournal.focusLevel}</h2>
        <Form onSubmit={handleSubmit}>
        <Col xs={12} sm={8} className="center-form">
            <InputGroup controlId="customRange2" label="Focus Level" className="mb-3">
                <Form.Control type="range" name="focusLevel" min="0" max="10" id="customRange2" className="form-range" onChange={handleChange} value={newJournal.focusLevel}></Form.Control>
            </InputGroup>
            <FloatingLabel controlId="floatingInput" label="Minutes completed" className="mb-3">
                <Form.Control type="text" name="description" placeholder="Minutes completed" onChange={handleChange} value={newJournal.description}></Form.Control>
            </FloatingLabel>
            <FloatingLabel controlId="floatingTextarea2" label="How was it?" className="mb-3">
                <Form.Control as="textarea" name="notes" placeholder="How was it?" style={{ height: '100px' }} onChange={handleChange} value={newJournal.notes}></Form.Control>
            </FloatingLabel>
            <Button variant="dark" type="submit" value="Log Journey" onClick={props.onHide}>Update</Button>
        </Col>
        </Form>
        </div>
      )
    }
    